import { IBenefitDTO } from '../../dto/benefits/benefit.dto';
import { IBenefitsDTO } from '../../dto/benefits/benefits.dto';

const benefitDTOs: IBenefitDTO[] = [
  {
    title: $localize`:@@page-search-content-benefits-section-option-0-title:Commitment to anonymity`,
    value: $localize`:@@page-search-content-benefits-section-option-0-value:A key feature of our anonymous Instagram viewer is its commitment to protecting user privacy. You can view accounts without worrying about revealing your identity, allowing you to explore content freely.`,
  },
  {
    title: $localize`:@@page-search-content-benefits-section-option-1-title:No registration required`,
    value: $localize`:@@page-search-content-benefits-section-option-1-value:Enjoy all features of our Instagram profile viewer without registration. It is particularly beneficial for those who prefer not to share personal information or go through the hassle of signing up.`,
  },
  {
    title: $localize`:@@page-search-content-benefits-section-option-2-title:User-friendly interface`,
    value: $localize`:@@page-search-content-benefits-section-option-2-value:Our Instagram viewer is built with simplicity and ease of use. The platform has been designed with user experience in mind, allowing users to find and access profiles with minimal hassle quickly. Clean design enhances user satisfaction, making it accessible to anyone, even those who are less familiar with technology. Use a convenient and fast search to view any accounts!`,
  },
  {
    title: $localize`:@@page-search-content-benefits-section-option-3-title:Comprehensive Content`,
    value: $localize`:@@page-search-content-benefits-section-option-3-value:Our service allows you to anonymously browse Instagram profiles — stories, highlights, photos, and reels, keeping your privacy intact.`,
  },
  {
    title: $localize`:@@page-search-content-benefits-section-option-4-title:Any device`,
    value: $localize`:@@page-search-content-benefits-section-option-4-value:You can browse Instagram profiles on any device you want — mobile, tablet, PC. To use our service you need a browser.`,
  },
  {
    title: $localize`:@@page-search-content-benefits-section-option-5-title:Option to download`,
    value: $localize`:@@page-search-content-benefits-section-option-5-value:You can download content while browsing Instagram accounts with our service! You can save photos, videos, and stories easily, without registering. Just enter the username, and you'll have access to all the available content.`,
  },
];

export const benefitsDTO: IBenefitsDTO = {
  title: $localize`:@@page-search-content-benefits-section-title:The essential benefits of our Instagram profile viewer`,
  benefits: benefitDTOs,
};
